import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useT } from '~app/core/BundleProvider';

const Footer = ({ navRef }) => {
  const t = useT();

  return (
    <nav className="Footer__layout" ref={navRef} tabIndex="-1">
      <div className="Footer__group">
        <NavLink to="/info" className="Footer__nav-link">
          {t('sup-info')}
        </NavLink>
      </div>
      <div className="Footer__group Footer__logos">
        <a
          href={t('biointeractive.org')}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={require('~app/resources/images/logos/BiointeractiveLogo.svg')}
            alt="HHMI Biointeractive"
            width="150"
          />
        </a>
      </div>
    </nav>
  );
};

Footer.propTypes = {
  navRef: PropTypes.func,
};

export default Footer;
